import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1489d3ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-animation-panel" }
const _hoisted_2 = { class: "animation-pool" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "animation-text" }

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { TurningMode } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import { Button } from 'ant-design-vue'

interface Animations {
  label: string
  value: TurningMode
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideAnimationPanel',
  setup(__props) {

const { t, locale } = useI18n();

const slidesStore = useSlidesStore()
const { slides, currentSlide } = storeToRefs(slidesStore)

const currentTurningMode = computed(() => currentSlide.value.turningMode || 'slideY')

const animations: Animations[] = [
  { label: t(`public.specialEffects.no`), value: 'no' },
  { label: t(`public.specialEffects.fade`), value: 'fade' },
  { label: t(`public.specialEffects.slideX`), value: 'slideX' },
  { label: t(`public.specialEffects.slideY`), value: 'slideY' },
  // { label: '无', value: 'no' },
  // { label: '淡入淡出', value: 'fade' },
  // { label: '左右推移', value: 'slideX' },
  // { label: '上下推移', value: 'slideY' },
]

const { addHistorySnapshot } = useHistorySnapshot()

// 修改播放时的切换页面方式
const updateTurningMode = (mode: TurningMode) => {
  if (mode === currentTurningMode.value) return
  slidesStore.updateSlide({ turningMode: mode })
  addHistorySnapshot()
}

// 将当前页的切换页面方式应用到全部页面
const applyAllSlide = () => {
  const newSlides = slides.value.map(slide => {
    return {
      ...slide,
      turningMode: currentSlide.value.turningMode,
    }
  })
  slidesStore.setSlides(newSlides)
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(animations, (item) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["animation-item", { 'active': _unref(currentTurningMode) === item.value }]),
          key: item.label,
          onClick: ($event: any) => (updateTurningMode(item.value))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['animation-block', item.value])
          }, null, 2),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1)
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createVNode(_unref(Button), {
      style: {"width":"100%"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (applyAllSlide()))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(`public.specialEffects.useAll`)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})